export default "__VITE_ASSET__BA$0fEAJ__"